import { type JSX, useEffect, useState } from "react";

import { Dialog, OverlayDialogContent } from "common/components/ui/Dialog";

import { useActiveConversationContext } from "../context/ActiveConversationContext";
import useActiveConversationState from "../hooks/useActiveConversationState";

export default function MobileConversation({
  children,
}: {
  children: JSX.Element;
}) {
  const { activeConversation } = useActiveConversationContext();
  const { resetActiveConversation } = useActiveConversationState();
  const [isOpen, setIsOpen] = useState(!!activeConversation);

  useEffect(() => {
    if (activeConversation) {
      setIsOpen(true);
    }
  }, [activeConversation]);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open);
        if (!open) {
          resetActiveConversation();
        }
      }}
    >
      <OverlayDialogContent>{children}</OverlayDialogContent>
    </Dialog>
  );
}
